module.exports = __webpack_public_path__ + "img/ts7.f5159e95.png";